import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m1.018 2.699 4.89-.666.002 4.716-4.887.028zm4.887 4.593.004 4.72-4.887-.672V7.26zm.593-5.346L12.98 1v5.689l-6.482.051zm6.484 5.39L12.98 13l-6.482-.915-.01-4.759Z" }, null, -1)
  ]))]))
}
export default { render: render }